//
//
//
//
//

import { Toast } from "vant";
import { xtLoginJsPath } from '@/config/project-config'
export default {
  name: "wxLoginBack",
  data() {
    return {
      xtLoginJsPath: xtLoginJsPath,
      userInfo:{}
    };
  },
  components: {},
  methods: {
    // getUrlCode() {
    //   const url = window.location.search
    //   const theRequest = new Object()
    //   if (url.indexOf("?") != -1) {
    //     let str = url.substr(1)
    //     let strs = str.split("&")
    //     for(let i = 0; i < strs.length; i ++) {
    //       theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
    //     }
    //   }
    //   return theRequest
    // },
    initWxUser () {
      // const local = window.location.href
      const code = this.$route.query.code
      const param = {}
      param.wxLoginAccessCode = code
      // param.wxLoginAccessState = state
      this.$store
        .dispatch("user/fnWxLoginQuery", JSON.stringify(param))
        .then((res) => {
          if (res.data.retCode == 1) {
            // this.userInfo = res.data.obj
            if (res.data.obj.id == "-1") {
              // 进入到注册页面
                 this.$router.push({path:"wxLoginBackRegister",query:{"userInfo": JSON.stringify(res.data.obj)}})
            } else {
              // 直接登录
              this.doLogin(res.data.obj)
            }
          } else {
            this.$router.push({path:"/login"})
            Toast(res.data.retMsg);
          }
        });
    },
    doLogin (user) {
      console.log(JSON.stringify(user))
      user.loginType = 3
      this.$store.dispatch('user/fnLoginNoCheckDoLogin',JSON.stringify(user)).then(res=>{
        if(res.data.retCode == 1){
          Toast('登录成功')
          this.fnHandleUser(res.data.obj)
        }else{
          Toast(res.data.retMsg)
        }
      })
    },
    fnHandleUser(obj) { // 处理登录后用户信息
      // 保存到token中
      this.$store.commit('setUserInfo',obj)
      if (localStorage.getItem('fromPage')) {
        let redirect = localStorage.getItem('fromPage')
        this.$router.push(redirect)
      } else {
        this.$router.push({path: '/'})
      }
      // this.$router.push({path: '/'})
      // if(window.opener!=null){
      //   window.opener.location.reload()//刷新父页面
      // }
      this.$nextTick(()=>{
        localStorage.setItem('alreadyLogin', 'alreadyLogin' + new Date().getTime() + '')
      })
      // // 跳转到用户中心
      // this.fnGotoUserCenter({
      //   self_redirect: '1',
      //   sucessCallBack: function () {
      //     if(window.opener!=null){
      //       window.opener.location.reload()//刷新父页面
      //     }
      //   }
      // })
    }
  },
  created() {
    // this.initWxUser()
  }
}



// WEBPACK FOOTER //
// ./src/pages/login/wxLoginBack.vue